import { Dispatch, FC, SetStateAction, useEffect, useState } from 'react';
import { Alert, Badge, Button, Table } from '../../components';
import { Enum, OfflineDepositActivation, Pagination, ReduxState, Transaction, Wallet } from 'interfaces';
import { WalletSummary } from '../walletSummary/walletSummary';
import { ColumnType } from 'antd/lib/table';
import CoinIcon from '../../../utilities/components/coinIcon/coinIcon.index';
import { BsFillInfoSquareFill } from 'react-icons/bs';
import { ReportDetailModal } from '../../reports/reportDetailModal/reportDetailModal.index';
import { getTransactions } from '../../reports/reports.service';
import { ConfigProvider, Divider, Pagination as AntPagination, Spin } from 'antd';
import fa_IR from 'antd/locale/fa_IR';
import { getTransactionStates } from 'services';
import { get, getTransactionBadgeType } from '../../../scripts';
import { Card } from 'utilities/components';
import { DepositMethods } from './deposit.data';
import { __DepositMethodsEnum } from './deposit.interface';
import { BuyPaymentCardToCardMethod } from './methods/cardToCard/cardToCard.index';
import { BuyPaymentCashInMethod } from './methods/cashIn/cashIn.index';
import BuyPaymentOfflineMethod from './methods/offline/offline.index';
import { API } from 'data/30pay.api';
import { BuyPaymentDirectMethod } from './methods/direct/buyPaymentDirectMethod.index';
import { connect, ConnectedProps } from 'react-redux';
import { ReactComponent as InfoIcon } from 'assets/icons/Info.svg';
import { BankDisruptionModal } from '../../components/bankDisruptionModal/bankDisruptionModal.index';

interface OwnProps {
    wallet?: Wallet;
    hideBalances: boolean;
    setHideBalances: Dispatch<SetStateAction<boolean>>;
}

type Props = OwnProps & ConnectedProps<typeof connector>;

const Deposit: FC<Props> = (props) => {
    const [detailModalOpen, setDetailModalOpen] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(true);
    const [filtersLoading, setFiltersLoading] = useState<boolean>(true);
    const [transactionStates, setTransactionStates] = useState<Enum[]>();
    const [selectedTransactionState, setSelectedTransactionState] = useState<Enum>();
    const [selectedTransaction, setSelectedTransaction] = useState<Transaction>();
    const [transactions, setTransactions] = useState<Pagination<Transaction>>();
    const [page, setPage] = useState<number>(1);
    const [pageSize, setPageSize] = useState<number>(10);
    const [isCardToCardActive, setIsCardToCardActive] = useState<boolean>();
    const [isOfflineDepositActive, setIsOfflineDepositActive] = useState<boolean>();
    const [isCashInActive, setIsCashInActive] = useState<boolean>();
    const [isGatewayActive, setIsGatewayActive] = useState<boolean>();
    const [stage, setStage] = useState<__DepositMethodsEnum>(__DepositMethodsEnum.cardToCard);

    useEffect(() => {
        get<{ isActive: boolean }>(API.siteSettings.cardToCardSettingActivation)
            .then((res) => setIsCardToCardActive(res.value.value.isActive))
            .catch((e) => console.log(e));

        get<OfflineDepositActivation>(API.siteSettings.offlineDepositActivation)
            .then((res) => setIsOfflineDepositActive(res.value.value.isActive))
            .catch((e) => console.log(e));

        get<{ isCashInActive: boolean }>(API.siteSettings.cashInActivation)
            .then((res) => setIsCashInActive(res.value.value.isCashInActive))
            .catch((e) => console.log(e));

        get<{ isActive: boolean; maximumDepositAmount: number }>(API.siteSettings.gatewaySettingsActivation)
            .then((res) => setIsGatewayActive(res.value.value.isActive))
            .catch((e) => console.log(e));
    }, []);
    const renderAlert = () => {
        switch (stage) {
            case __DepositMethodsEnum.direct:
                return (
                    <Alert
                        className={'mt-6'}
                        variant={'warning'}
                        message={
                            'واریز درگاهی، به دستور بانک مرکزی تا اطلاع ثانوی مسدود می‌باشد. جهت واریز می‌توانید از واریز شناسه‌دار استفاده نمایید.'
                        }
                    />
                );
            case __DepositMethodsEnum.cashInDeposit:
                return (
                    <Alert
                        className={'mt-6'}
                        variant={'info'}
                        message={
                            'زمان تقریبی اعلام تراکنش‌های ناموفق در سیکل‌های استاندارد پایا می‌باشد. برگشت وجه به حساب واریز کننده حداکثر تا ۷۲ ساعت پس از واریز انجام می‌گیرد.'
                        }
                    />
                );
        }
    };
    const renderHelperAlerts = () => {
        switch (stage) {
            case __DepositMethodsEnum.direct:
                return (
                    <Alert
                        variant={'info'}
                        message={
                            'حتماً به آدرس صفحه‌ی درگاه بانکی دقت نموده و تنها پس از اطمینان از حضور در سایت‌های سامانه‌ی شاپرک مشخصات کارت بانکی خود را وارد نمایید.'
                        }
                    />
                );
            case __DepositMethodsEnum.cashInDeposit:
                return (
                    <>
                        <Alert
                            variant={'info'}
                            message={
                                'واریز وجه فقط از روش‌های پایا، ساتنا و حساب به حساب و تنها از شماره شبای اعلام‌شده و مورد تایید امکان‌پذیر است و زمان دریافت وجه برحسب هر روش متفاوت خواهد بود. درصورتیکه مبلغ بیش از حد مجاز که بدستور بانک مرکزی (۲۵میلیون تومان) باشد واریز شما بررسی می‌گردد. برای پیگیری باسرعت بالاتر از پشتیبانی پیگیری نمایید.'
                            }
                        />
                        <Alert
                            variant={'warning'}
                            message={
                                'لطفا برای واریز از شماره شبایی که در پلتفرم ثبت کرده‌اید استفاده نمایید. در غیر این صورت مبلغ واریزی شما به حسابتان برگشت خواهد خورد.'
                            }
                        />
                    </>
                );
            case __DepositMethodsEnum.cardToCard:
                return (
                    <>
                        <Alert
                            variant={'success'}
                            message={<>پردازش تراکنش های کارت به کارت در تمام ساعات شبانه روز اتوماتیک میباشد.</>}
                        />
                        <Alert
                            variant={'warning'}
                            message={
                                <>
                                    ۱. شماره کارت مبدأ باید به نام خودتان باشد و در ۳۰پی ثبت شده باشد. در غیر این صورت،
                                    مبلغ به حساب شما واریز نخواهد شد و برای بازگشت وجه به حساب مبدا، لازم است با
                                    پشتیبانی تماس بگیرید.
                                    <br />
                                    ۲. سقف مبلغ واریز کارت به کارت، روزانه ۱۰٬۰۰۰٬۰۰۰ تومان برای هر کارت است.
                                </>
                            }
                        />
                        <Alert
                            variant={'info'}
                            message={
                                <div className="flex flex-col">
                                    <p>
                                        • ابتدا یکی از کارت‌های ثبت‌شده در حساب کاربری خود را انتخاب یا شماره کارت جدید
                                        به نام خود در بخش افزودن کارت ثبت کنید.
                                    </p>
                                    <p>
                                        • در اپلیکیشن بانکی موردنظر یا دستگاه خودپرداز، شماره کارت مقصد سی پی را وارد
                                        کنید.
                                    </p>
                                    <p>
                                        • پس از اتمام عملیات، مبلغ واریزی طی بازه زمانی ۵ دقیقه تا ۳ ساعت به کیف پول شما
                                        افزوده خواهد شد.
                                    </p>
                                </div>
                            }
                        />
                    </>
                );
            case __DepositMethodsEnum.offlineDeposit:
                return (
                    <>
                        <Alert
                            variant={'info'}
                            message={
                                <>
                                    ۱. تصویر فیش واریزی حتما شامل یکی از موارد شماره شبا، حساب و یا کارت باشد. در غیر
                                    اینصورت تأیید مبلغ واریزی از طریق پشتیبانی قابل پیگیری نیست.
                                    <br />
                                    ۲. در صورت شارژ نشدن کیف پول بعد از ۱۲ ساعت در روزهای کاری و ۲۴ ساعت در روزهای تعطیل
                                    رسمی با پشتیبانی تماس بگیرید.
                                </>
                            }
                        />
                        <Alert
                            variant={'warning'}
                            message={`واریزی حتما از حساب به نام ${props.user?.fullName ?? 'خودتان'} باشد. در غیر این صورت تأیید نخواهد شد و باید از طریق پشتیبانی پیگیری کنید.`}
                        />
                        <Alert
                            variant={'warning'}
                            message={
                                <>
                                    ۱. کاربر گرامی لطفا جهت جلوگیری از طولانی شدن فرآیند تایید فیش واریزی از آپلود تصویر
                                    فیش واریزی بیش از یک بار اکیدا خودداری کنید.
                                    <br />
                                    ۲. کاربر گرامی،لطفا در هنگام پرداخت از طریق شعبه یا به صورت اینترنتی بخش توضیحات
                                    تراکنش را خالی بگذارید.
                                </>
                            }
                        />
                    </>
                );
        }
    };

    const handleTransactionDetail = (item: Transaction) => {
        setSelectedTransaction(item);
        setDetailModalOpen(true);
    };

    const handlePageChange = (page: number, pageSize: number) => {
        setPage(page);
        setPageSize(pageSize);
    };

    const buildQueryString = () => {
        const params = new URLSearchParams();
        params.append('type', '1'); // واریز - ثابت

        if (selectedTransactionState) {
            params.append('state', selectedTransactionState.id.toString());
        }

        return params.toString();
    };

    const fetchData = (page: number, pageSize: number) => {
        const queryString = buildQueryString();

        const finalQueryString = queryString ? `?${queryString}` : '';

        getTransactions(setLoading, setTransactions, page, pageSize, finalQueryString);
    };

    const columns: ColumnType<any>[] = [
        {
            title: 'ردیف',
            dataIndex: 'id',
            key: 'id',
            render: (text, record: Transaction, i) => <span className={'font-medium text-sm'}>{i + 1}</span>,
        },
        {
            title: 'ارز',
            dataIndex: 'market',
            key: 'market',
            render: (pair, record: Transaction) => (
                <div className={'flex items-center gap-3'}>
                    <CoinIcon symbol={record?.market.symbol} className={'w-8 h-8'} />
                    <span className={'text-sm font-bold'}>{record?.market.name}</span>
                    <span className={'text-xs font-medium'}>{record?.market?.symbol?.toUpperCase()}</span>
                </div>
            ),
        },
        {
            title: 'مقدار ارز',
            dataIndex: 'amount',
            key: 'amount',
            render: (text, record: Transaction) => (
                <span className={'font-medium text-sm'}>
                    {record.amount.toLocaleString()} {record.market.symbol}
                </span>
            ),
        },
        // {
        //     title: 'قیمت واحد',
        //     dataIndex: 'onPrice',
        //     key: 'onPrice',
        //     render: (text, record: Transaction) => (
        //         <span className={'font-medium text-sm'}>{record.onPrice.toLocaleString()} تومان</span>
        //     ),
        // },
        {
            title: 'نوع تراکنش',
            dataIndex: 'type',
            key: 'type',
            render: (text, record: Transaction) => <span className={'font-medium text-sm'}>{record.type.title}</span>,
        },
        {
            title: 'زمان',
            dataIndex: 'createdAt',
            key: 'createdAt',
            render: (text, record: Transaction) => (
                <div className={'flex items-center gap-1'}>
                    <span className={'font-medium text-sm'}>{new Date(record.createdAt).toLocaleDateString('fa')}</span>
                    <span className={'font-medium text-xs text-black-60'}>
                        {new Date(record.createdAt).toLocaleTimeString('fa')}
                    </span>
                </div>
            ),
        },
        {
            title: 'وضعیت',
            dataIndex: 'state',
            key: 'state',
            render: (text, record: Transaction) => (
                <Badge
                    type={getTransactionBadgeType(record.state.id) as 'success' | 'warning' | 'danger' | 'info'}
                    title={record.state.title}
                />
            ),
            align: 'center',
        },
        {
            title: 'جزئیات',
            dataIndex: 'details',
            key: 'details',
            render: (text, record: Transaction) => (
                <InfoIcon className={'text-primary-20 clickable'} onClick={() => handleTransactionDetail(record)} />
            ),
        },
    ];

    useEffect(() => {
        getTransactionStates(setFiltersLoading, setTransactionStates);
    }, []);

    useEffect(() => {
        fetchData(page, pageSize);
    }, [page, pageSize, selectedTransactionState]);

    function determineIsLoading(item: __DepositMethodsEnum) {
        switch (item) {
            case __DepositMethodsEnum.cardToCard:
                return isCardToCardActive === undefined;
            case __DepositMethodsEnum.direct:
                return isGatewayActive === undefined;
            case __DepositMethodsEnum.offlineDeposit:
                return isOfflineDepositActive === undefined;
            case __DepositMethodsEnum.cashInDeposit:
                return isCashInActive === undefined;
            default:
                return false;
        }
    }

    function determineIsDisabled(item: __DepositMethodsEnum) {
        switch (item) {
            case __DepositMethodsEnum.cardToCard:
                return isCardToCardActive === false;
            case __DepositMethodsEnum.direct:
                return isGatewayActive === false;
            case __DepositMethodsEnum.offlineDeposit:
                return isOfflineDepositActive === false;
            case __DepositMethodsEnum.cashInDeposit:
                return isCashInActive === false;
            default:
                return false;
        }
    }

    const sortedDepositMethods = [...DepositMethods].sort((a, b) => {
        const aDisabled = determineIsDisabled(a.key);
        const bDisabled = determineIsDisabled(b.key);

        if (aDisabled === bDisabled) return 0;

        return aDisabled ? 1 : -1;
    });
    return (
        <>
            <BankDisruptionModal variant="deposit" />
            {renderAlert()}
            {selectedTransaction && (
                <ReportDetailModal open={detailModalOpen} setOpen={setDetailModalOpen} item={selectedTransaction} />
            )}
            <div className={'flex items-start gap-6 mt-6 max-lg:flex-col-reverse'}>
                <Card className="flex-1" title="واریز ریالی" titleDivider>
                    <div className="flex flex-col gap-6 -mt-6">
                        <div className="h-[50px] flex items-center px-8 max-lg:px-6 gap-5 w-[calc(100%+48px)] -mr-6 border-b border-b-background overflow-auto scrollbar-hidden">
                            {sortedDepositMethods.map((item, index) => (
                                <div
                                    key={index}
                                    onClick={() => !determineIsLoading(item.key) && setStage(item.key)}
                                    className={`max-w-[150px] flex-1 flex items-center justify-center h-full border-b-[4px] clickable !transition-all 
                                    ${item.key === stage ? 'text-black-100  border-b-primary-100' : 'text-black-60 border-b-[#00000000]'}
                                    ${determineIsDisabled(item.key) ? 'opacity-20 pointer-events-none cursor-not-allowed' : ''}
                                    `}
                                >
                                    <Spin size="small" spinning={determineIsLoading(item.key)}>
                                        <label className="font-medium text-sm whitespace-nowrap clickable flex h-full items-center justify-center">
                                            {item.title}
                                        </label>
                                    </Spin>
                                </div>
                            ))}
                        </div>
                        {stage === __DepositMethodsEnum.direct && <BuyPaymentDirectMethod />}
                        {stage === __DepositMethodsEnum.cardToCard && <BuyPaymentCardToCardMethod />}
                        {stage === __DepositMethodsEnum.cashInDeposit && <BuyPaymentCashInMethod />}
                        {stage === __DepositMethodsEnum.offlineDeposit && (
                            <BuyPaymentOfflineMethod
                                onFinish={() => {
                                    setStage(__DepositMethodsEnum.cardToCard);
                                    fetchData(page, pageSize);
                                }}
                            />
                        )}
                    </div>
                </Card>
                <div className={'flex flex-1 flex-col'}>
                    <WalletSummary {...props} />
                    <div className={'flex flex-col gap-6 mt-6'}>{renderHelperAlerts()}</div>
                </div>
            </div>

            <div
                className={
                    'flex max-lg:flex-col justify-between items-center mt-6 w-full bg-white h-14 px-4 border border-primary-20 rounded-t-[8px] max-lg:rounded-[8px] max-lg:h-auto'
                }
            >
                <div
                    className={
                        'flex bg-white items-center gap-4 text-sm font-medium relative h-full justify-center overflow-x-scroll scrollbar-hidden max-lg:gap-4 max-lg:justify-start max-lg:w-full max-lg: whitespace-nowrap'
                    }
                >
                    {transactionStates?.map((state) => (
                        <div
                            key={state.id}
                            className="relative clickable h-full flex items-center"
                            onClick={() => {
                                setSelectedTransactionState(
                                    selectedTransactionState?.id === state.id ? undefined : state,
                                );
                            }}
                        >
                            <span
                                className={`py-2 px-4 transition duration-300 ease-in-out ${
                                    selectedTransactionState?.id === state.id ? 'text-black-100' : 'text-black-60'
                                }`}
                            >
                                {state.title}
                            </span>
                            {selectedTransactionState?.id === state.id && (
                                <div className="absolute left-0 right-0 bottom-0 h-1 bg-primary-100 rounded-t-[2.5px]" />
                            )}
                        </div>
                    ))}
                </div>
            </div>

            <Table
                className={'border-t-0 rounded-t-0 max-lg:hidden'}
                columns={columns}
                dataSource={transactions?.items}
                loading={loading}
                rowKey="id"
                pagination={false}
            />

            <ul className={'flex flex-col gap-4 mt-4 lg:hidden'}>
                {transactions?.items?.slice((page - 1) * pageSize, page * pageSize).map((item) => (
                    <li className={'p-4 rounded-[8px] bg-white border border-primary-20'} key={item?.trackingCode}>
                        <div className={'flex items-center justify-between'}>
                            <div className={'flex items-center gap-2'}>
                                <CoinIcon symbol={item?.market?.symbol} className={'w-8 h-8'} />
                                <span className={'text-sm font-bold'}>{item?.market?.name}</span>
                                <span className={'text-xs font-medium'}>{item?.market.symbol?.toUpperCase()}</span>
                            </div>
                            <Badge
                                type={
                                    item.state.title.includes('ناموفق')
                                        ? 'danger'
                                        : item.state.title.includes('موفق') || item.state.title.includes('انجام شده')
                                          ? 'success'
                                          : item.state.title.includes('انتظار')
                                            ? 'info'
                                            : item.state.title.includes('لغو')
                                              ? 'warning'
                                              : undefined
                                }
                                title={item.state.title}
                            />
                        </div>
                        <Divider />
                        <div className={'flex justify-between items-center'}>
                            <div className={'flex flex-col'}>
                                <p className={'text-sm font-bold'}>قیمت واحد:</p>
                                <span className={'text-sm font-medium text-darkPurple-60'} dir={'ltr'}>
                                    {item.onPrice.toLocaleString()} تومان
                                </span>
                            </div>
                            <div className={'flex flex-col'}>
                                <p className={'text-sm font-bold'}>مقدار ارز:</p>
                                <span className={'text-sm font-medium text-darkPurple-60'} dir={'ltr'}>
                                    {item.amount.toLocaleString()} {item.market.symbol}
                                </span>
                            </div>
                            <div className={'flex flex-col'}>
                                <p className={'text-sm font-bold'}>نوع تراکنش:</p>
                                <span className={'text-sm font-medium text-darkPurple-60'}>{item.type.title}</span>
                            </div>
                        </div>
                        <div className={'flex items-center justify-between mt-2'}>
                            <div className={'flex flex-col'}>
                                <p className={'text-sm font-bold'}>زمان:</p>
                                <div className={'flex items-center gap-1'}>
                                    <span className={'font-medium text-sm'}>
                                        {new Date(item.createdAt).toLocaleDateString('fa')}
                                    </span>
                                    <span className={'font-medium text-xs text-black-60'}>
                                        {new Date(item.createdAt).toLocaleTimeString('fa')}
                                    </span>
                                </div>
                            </div>
                            <div className={'flex flex-col'}>
                                <Button type={'default'} onClick={() => handleTransactionDetail(item)}>
                                    جزئیات
                                </Button>
                            </div>
                        </div>
                    </li>
                ))}
            </ul>

            <ConfigProvider locale={fa_IR}>
                <AntPagination
                    current={page}
                    pageSize={pageSize}
                    total={transactions?.pagination?.totalCount}
                    onChange={handlePageChange}
                    className="mt-4 justify-center"
                    style={{ direction: 'ltr' }}
                    showSizeChanger={true}
                    onShowSizeChange={(current, size) => handlePageChange(current, size)}
                />
            </ConfigProvider>
        </>
    );
};

const mapStateToProps = (state: ReduxState) => ({
    isAuth: state.authStatus,
    user: state.userData,
});

const connector = connect(mapStateToProps);
export default connector(Deposit);
